import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { connect } from 'react-redux';
import { SketchPicker } from 'react-color';
import {
  Row,
  Col,
  Input,
  Upload,
  message,
  Icon,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  axiosAuthInstance,
  axiosEmptyInstance,
  API_END_POINTS,
} from 'api';
import { NOTIFICATION } from 'store/actionTypes';
import { notificationActions } from 'store/actions';
import { MESSAGES } from 'appconstants';
import {
  SpH5,
  SpError,
  SpText,
} from 'components/DesignKit';
import {
  SpColor,
  SpCover,
  SpPopover,
  SpWatch,
} from 'components/PaymentWidgetDesignKit';
import Previewicon from 'components/NavIcons/previewIcon';
import Uploadicon from 'components/NavIcons/uploadIcon';
import imageOnError from 'utils/imageOnError';

type Props = {
  brandingInfo: Object,
  setNotification: Function,
  businessInfo: Object,
  brandingUpdate: Function,
};

const Branding = forwardRef((props: Props, ref) => {
  const {
    brandingInfo,
    setNotification,
    businessInfo,
    brandingUpdate,
  } = props;

  const [, forceUpdate] = useState();
  const [shopName, setShopName] = useState(brandingInfo.shopName);
  const [address, setAddress] = useState(brandingInfo.shopAddress);
  const [themeColor, setThemeColor] = useState(brandingInfo.themeColor || '#007bff');
  const [textColor, setTextColor] = useState(brandingInfo.textColor || '#007bff');
  const [logo, setLogo] = useState(brandingInfo.logo);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [displayColorPicker1, setDisplayColorPicker1] = useState(false);
  const [loader, setLoading] = useState(false);
  const [preview, setPreview] = useState(brandingInfo.logo ? (
    // eslint-disable-next-line max-len
    <img src={`${brandingInfo.logo}?time=${new Date().getTime()}`} alt="" onError={event => imageOnError(event)} style={{ width: '100%' }} />) : '');
  // eslint-disable-next-line no-unused-vars
  const [fileName, setFileName] = useState('');
  const simpleValidator = useRef(new SimpleReactValidator());

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };


  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (e) => {
    setThemeColor(e.hex);
    brandingInfo.themeColor = e.hex;
    brandingUpdate(brandingInfo);
  };

  const updateColor = (e) => {
    setThemeColor(e.currentTarget.value);
    brandingInfo.themeColor = e.currentTarget.value;
    brandingUpdate(brandingInfo);
  };


  const handleClick1 = () => {
    setDisplayColorPicker1(!displayColorPicker1);
  };
  const handleClose1 = () => {
    setDisplayColorPicker1(false);
  };

  const handleChange1 = (e) => {
    setTextColor(e.hex);
    brandingInfo.textColor = e.hex;
    brandingUpdate(brandingInfo);
  };

  const updateColor1 = (e) => {
    setTextColor(e.currentTarget.value);
    brandingInfo.textColor = e.currentTarget.value;
    brandingUpdate(brandingInfo);
  };

  const uploadButton = (
    <div>
      {loader ? <Icon type="loading" /> : <Uploadicon />}
      <div className="ant-upload-text mt-2">Click or drag the file here to upload</div>
      <div className="mt-2"><SpText color="rgba(0, 0, 0, 0.45)">Support extension：.pdf .jpg .png</SpText></div>
    </div>
  );

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    const PDF = 'application/pdf';
    const IMAGE = 'image/*';
    const pattern = file.type.match(IMAGE) || file.type.match(PDF);
    if (!pattern) {
      message.error('File is not image or pdf');
      return false;
    }
    if (pattern && !isLt5M) {
      message.error('File must smaller than 5MB!');
      return false;
    }
    return true;
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file);
  });

  const fileUpload = async (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    try {
      setLoading(true);
      const file = info.file.originFileObj;
      if (file) {
        const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.UPLOAD_KIOSK}`);
        await axiosEmptyInstance.put(entity, await fileReader(file), { headers: { 'Content-Type': file.type } });
        const { data: { entity: { fileUrl } } } = await axiosAuthInstance.post(`${API_END_POINTS.UPLOAD_KIOSK}`, { fileUrl: entity });
        setLogo(fileUrl);
        brandingInfo.logo = fileUrl;
        brandingUpdate(brandingInfo);
        const pattern = /image*/;
        if (file.type.match(pattern)) {
          getBase64(file, imageUrl => {
            setPreview(<img src={imageUrl} alt="..." style={{ width: '115px' }} />);
          });
        } else {
          setPreview(<Previewicon />);
        }
        setFileName(info.file.name);
      }
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: MESSAGES.FILE_UPLOAD.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      brandingInfo.shopName = shopName;
      brandingInfo.shopAddress = address;
      brandingInfo.themeColor = themeColor;
      brandingInfo.textColor = textColor;
      brandingInfo.logo = logo;
      return true;
    },
  }));

  return (
    <>
      <div style={{ height: '400px' }}>
        <Row>
          <Col span={5}>
            <label htmlFor=""><SpH5>Theme  Background Color</SpH5></label>
            <div className="d-flex ml-1">
              <div>
                <SpWatch onClick={handleClick}>
                  <SpColor className="color" style={{ backgroundColor: `${themeColor}` }} />
                </SpWatch>
                {displayColorPicker ? (
                  <>
                    <SpPopover>
                      <SpCover onClick={handleClose} />
                      <SketchPicker color={themeColor} onChange={handleChange} />
                    </SpPopover>
                  </>
                ) : null}
              </div>
              <Input
                style={{ width: '111px' }}
                className="ml-3"
                value={themeColor}
                onChange={updateColor}
              />
            </div>
            <SpError>
              {simpleValidator.current.message('theme color', themeColor, 'required')}
            </SpError>
          </Col>
          <Col span={3}>
            <label htmlFor=""><SpH5>Text  Color</SpH5></label>
            <div className="d-flex ml-1">
              <div>
                <SpWatch onClick={handleClick1}>
                  <SpColor className="color" style={{ backgroundColor: `${textColor}` }} />
                </SpWatch>
                {displayColorPicker1 ? (
                  <>
                    <SpPopover>
                      <SpCover onClick={handleClose1} />
                      <SketchPicker color={textColor} onChange={handleChange1} />
                    </SpPopover>
                  </>
                ) : null}
              </div>
              <Input
                style={{ width: '111px' }}
                className="ml-3"
                value={textColor}
                onChange={updateColor1}
              />
            </div>
            <SpError>
              {simpleValidator.current.message('text color', textColor, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6}>
            <label htmlFor=""><SpH5>{businessInfo.bussinessType === 'RESTAURANT' ? 'Shop Name' : 'Temple Name'}</SpH5></label>
            <Input
              type="text"
              value={shopName}
              onChange={(e) => {
                setShopName(e.currentTarget.value);
                brandingInfo.shopName = e.currentTarget.value;
                brandingUpdate(brandingInfo);
              }}
            />
            <SpError>
              {simpleValidator.current.message('name', shopName, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6}>
            <label htmlFor=""><SpH5>{businessInfo.bussinessType === 'RESTAURANT' ? 'Shop Address' : 'Temple Address'}</SpH5></label>
            <Input
              type="text"
              value={address}
              onChange={(e) => {
                setAddress(e.currentTarget.value);
                brandingInfo.shopAddress = e.currentTarget.value;
                brandingUpdate(brandingInfo);
              }}
            />
            <SpError>
              {simpleValidator.current.message('address', address, 'required')}
            </SpError>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6}>
            <label htmlFor=""><SpH5>Upload Logo Image <span style={{ color: 'red' }}>*</span></SpH5></label>
            <Upload
              name="avatar"
              listType="picture-card upload-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={fileUpload}
            >
              {preview || uploadButton}
            </Upload>
            <SpError>
              {simpleValidator.current.message('logo', logo, 'required')}
            </SpError>
          </Col>
        </Row>
      </div>
    </>
  );
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Branding);
